/**
 * Utilitários para formatação e manipulação de valores monetários
 */

/**
 * Formata valor numérico para exibição em Real brasileiro
 * Exemplo: 1234.56 -> "R$ 1.234,56"
 */
export function formatCurrency(value: string | number | null | undefined): string {
  if (!value && value !== 0) return ''
  const numValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d,.-]/g, '').replace(',', '.')) : value
  if (Number.isNaN(numValue)) return ''
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(numValue)
}

/**
 * Converte entrada de dígitos para valor monetário (centavos)
 * Exemplo: "380" -> "3.80" (380 centavos = R$ 3,80)
 */
export function digitsToCurrency(digits: string): string {
  if (!digits) return ''
  // Remove tudo exceto dígitos
  const onlyDigits = digits.replace(/\D/g, '')
  if (!onlyDigits) return ''
  
  // Converte para número e divide por 100 (centavos)
  const cents = parseInt(onlyDigits, 10)
  if (Number.isNaN(cents)) return ''
  
  return (cents / 100).toFixed(2)
}

/**
 * Remove formatação monetária e retorna apenas números com ponto decimal
 * Exemplo: "R$ 1.234,56" -> "1234.56"
 */
export function unformatCurrency(value: string): string {
  if (!value) return ''
  // Remove tudo exceto dígitos, vírgula e ponto
  const cleaned = value.replace(/[^\d,.]/g, '')
  if (!cleaned) return ''
  
  // Se tem vírgula, assume formato brasileiro (vírgula como decimal)
  if (cleaned.includes(',')) {
    // Remove pontos (milhares) e substitui vírgula por ponto
    const withoutThousands = cleaned.replace(/\./g, '')
    return withoutThousands.replace(',', '.')
  }
  
  // Se só tem pontos, pode ser formato com ponto decimal ou milhares
  // Se tem múltiplos pontos, assume que o último é decimal
  const parts = cleaned.split('.')
  if (parts.length > 2) {
    const integerPart = parts.slice(0, -1).join('')
    const decimalPart = parts[parts.length - 1]
    return `${integerPart}.${decimalPart}`
  }
  
  return cleaned
}
